"use strict";

export default function setupExpedicoesArchive() {
    const grid = document.querySelector(
        ".archive-expedicoes .o-page-blog__grid",
    );
    if (!grid) return;

    const loading = document.querySelector(".o-expedition-loading");

    function showLoading() {
        if (loading) loading.style.display = "block";
        grid.style.display = "none";
    }

    function hideLoading() {
        if (loading) loading.style.display = "none";
        grid.style.display = "";
        grid.classList.remove("is-loading");
    }

    const filterItems = document.querySelectorAll(
        ".c-select, .c-filtro-expedicoes__item.no-icon",
    );

    document.addEventListener("click", (e) => {
        const arrow = e.target.closest(".arrow");
        const item = e.target.closest(".c-filtro-expedicoes__item");

        if (arrow && item) {
            const open = item.classList.contains("open");
            filterItems.forEach((i) => i.classList.remove("open"));
            if (!open) item.classList.add("open");
            e.stopPropagation();
        }
    });

    document.addEventListener("click", () => {
        filterItems.forEach((i) => i.classList.remove("open"));
    });

    document.addEventListener("click", (e) => {
        const option = e.target.closest(".option, .c-select__option");
        if (!option) return;

        const parent = option.closest("[data-filter]");
        if (!parent) return;

        const value = option.dataset.value ?? ""; // <- precisa existir no HTML
        parent.dataset.value = value;

        const label = parent.querySelector(".label, .c-select__label");
        if (label) label.innerText = option.innerText;

        parent.classList.add("selected");
        parent.classList.remove("open");

        updateFilters();
    });

    let selectedYear = "";
    let selectedMonth = "";

    document.querySelectorAll(".year-btn").forEach((btn) => {
        btn.addEventListener("click", () => {
            document
                .querySelectorAll(".year-btn")
                .forEach((b) => b.classList.remove("is-active"));
            btn.classList.add("is-active");
            selectedYear = btn.dataset.year || "";
            updateFilters();
        });
    });

    document.querySelectorAll(".month-btn").forEach((btn) => {
        btn.addEventListener("click", () => {
            if (btn.classList.contains("is-disabled")) return;
            document
                .querySelectorAll(".month-btn")
                .forEach((b) => b.classList.remove("is-active"));
            btn.classList.add("is-active");
            selectedMonth = btn.dataset.month || "";
            updateFilters();
        });
    });

    function getFilters() {
        return {
            ano: selectedYear || "",
            mes: selectedMonth || "",
            destino:
                document.querySelector('[data-filter="destinos"]')?.dataset
                    .value || "",
            preferencia:
                document.querySelector('[data-filter="preferencia"]')?.dataset
                    .value || "",
            orderby:
                document.querySelector('[data-filter="orderby"]')?.dataset
                    .value || "date",
        };
    }

    function updateFilters() {
        const f = getFilters();
        showLoading();

        const qs = new URLSearchParams(f).toString();

        const ajaxUrl = window.ajaxurl || "/wp-admin/admin-ajax.php";

        fetch(`${ajaxUrl}?action=filtrar_expedicoes_archive&${qs}`, {
            method: "GET",
            credentials: "same-origin",
            headers: { "X-Requested-With": "XMLHttpRequest" },
        })
            .then((r) => r.text())
            .then((html) => {
                grid.innerHTML = html;
                hideLoading();
            })
            .catch(() => {
                grid.innerHTML =
                    "<p>Erro ao carregar expedições. Tente novamente.</p>";
                hideLoading();
            });
    }
}
